import React from 'react';
import { ContentBlock } from '@whitelabel/component-library';
import { IPage } from '@whitelabel/helpers/types';
import { StyledDisclaimer } from './styledDisclaimer';

interface IDisclaimerProps {
  disclaimer?: IPage;
}

const Disclaimer = ({ disclaimer }: IDisclaimerProps): JSX.Element => (
  <StyledDisclaimer>
    <ContentBlock blocks={disclaimer?.body} />
  </StyledDisclaimer>
);

export default Disclaimer;
